var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBscchain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75222 11L2.76382 15.2551L6.37933 17.3826V19.8738L0.647896 16.5123V9.75575L2.75222 11ZM2.75222 6.74498V9.22452L0.646606 7.97894V5.49941L2.75222 4.25384L4.86814 5.49941L2.75222 6.74498ZM7.88923 5.49941L9.99484 4.25384L12.1108 5.49941L9.99484 6.74498L7.88923 5.49941Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27375 14.3731V11.882L6.37936 13.1276V15.6071L4.27375 14.3731ZM7.88926 18.2749L9.99487 19.5205L12.1108 18.2749V20.7544L9.99487 22L7.88926 20.7544V18.2749ZM15.1306 5.49941L17.2362 4.25384L19.3521 5.49941V7.97895L17.2362 9.22452V6.74498L15.1306 5.49941ZM17.2362 15.2551L17.2478 11L19.3534 9.75446V16.511L13.622 19.8725V17.3813L17.2362 15.2551Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7263 14.3732L13.6207 15.6071V13.1276L15.7263 11.882V14.3732Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7263 7.62686L15.7379 10.118L12.1121 12.2455V16.5109L10.0065 17.7449L7.90087 16.5109V12.2455L4.27504 10.118V7.62686L6.38968 6.38129L9.99358 8.51914L13.6194 6.38129L15.7353 7.62686H15.7263ZM4.27375 3.3731L9.99487 0L15.7263 3.3731L13.6207 4.61867L9.99487 2.48083L6.37936 4.61867L4.27375 3.3731Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBscchain);
export default __webpack_public_path__ + "static/media/bscchain.6a638b19852352be575b087d0ed856b6.svg";
export { ForwardRef as ReactComponent };